import { styled } from 'styled-components';
export const Wrapper = styled.div `
  position: sticky;
  top: ${({ $offset }) => `${$offset}px`};
  gap: 24px;
  display: flex;
  flex-direction: column;
`;
